<template>
    <div class="d-flex flex-column">
        <label for="fileInput" class="btn btn-soft-secondary" :title="showTitle">
            <span v-if="!selectedFiles.length">{{ $tc('common.choose_file_button', multiple ? 2 : 1) }}</span>
            <span v-else>{{ truncateFileName(selectedFiles[0].name) }}</span>
        </label>
        <input type="file" id="fileInput" class="d-none" ref="fileInput" @change="handleFileChange" :accept="accept" :multiple="multiple" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectedFiles: [],
            text: 'Choose files',
        }
    },
    computed: {
        showTitle() {
            return this.selectedFiles.length > 0 ? this.selectedFiles[0].name : ''
        },
    },
    methods: {
        handleFileChange() {
            if (this.multiple) {
                const files = this.$refs.fileInput.files
                for (let i = 0; i < files.length; i++) {
                    this.selectedFiles.push(files[i])
                }
            } else {
                this.selectedFiles = []
                this.selectedFiles.push(this.$refs.fileInput.files[0])
            }

            this.$refs.fileInput.value = ''
            this.$emit('update:modelValue', this.selectedFiles)
        },
        removeFile(index) {
            this.selectedFiles.splice(index, 1)
            this.$emit('update:modelValue', this.selectedFiles)
        },
        truncateFileName(fileName) {
            if (fileName.length > 20) {
                return fileName.substring(0, 17) + '...'
            }
            return fileName
        },
    },
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
    props: {
        modelValue: Array,
        multiple: {
            type: Boolean,
            default: false,
        },
        accept: {
            type: String,
            default: '',
        },
    },
}
</script>

<style scoped>
.btn-soft-secondary {
    width: 100%;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0.5rem;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
